import { render } from "./LogoLoader.vue?vue&type=template&id=9c71c642&scoped=true&ts=true"
import script from "./LogoLoader.vue?vue&type=script&lang=ts"
export * from "./LogoLoader.vue?vue&type=script&lang=ts"

import "./LogoLoader.scss?vue&type=style&index=0&id=9c71c642&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c71c642"]])

export default __exports__